import {ReactNode} from 'react';

import {ComponentType} from '@sail/engine/dist/deprecated/view/props';

import {AppConfig} from '../../core/types';
import {AssistantContainer} from '../../core/components/AssistantContainer';
import {ErrorScreen} from '../../core/components/ErrorScreen';
import {StripeAssistantHeader} from './Header/StripeAssistantHeader';

type Props = {
  config: AppConfig;
  errorId?: string;
  header?: ReactNode | ComponentType;
};

export function ErrorBoundaryFallback({
  config,
  errorId,
  header = StripeAssistantHeader,
}: Props) {
  return (
    <AssistantContainer header={header}>
      <ErrorScreen config={config} errorId={errorId} />
    </AssistantContainer>
  );
}
